import React, { useEffect, useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";
import "./horizonTable.css";
import { addLogoAndFormHeader, applyFooterAllPages, getInnerTableWidth, buildSharePointFileName, toDdMmYyyy, addedByName } from "../../utils/formPdfHelpers.js";
import CheckTick from "../../assets/icons/Check-Tick.png";
import "../forms/formTitle.css";
import "../forms/themeCheckbox.css";
import AdminTaylorImportModal, { adminIsPrimaryAdmin } from "./AdminTaylorImportModal";
import { ensureFormUuid, noopCreateSuccess } from "../../utils/formUuid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseSiteRegisterDate, formatSiteRegisterDate, siteRegisterDatePickerProps } from "./adminEditModalTheme";

import { canEditDeleteRecords } from "../../utils/rolePermissions";
const THEME = "#8b1634";

const PDF_TICK = "__TICK__";
const PDF_SIZE_PLACEHOLDER_GRAY = [211, 211, 211];

function getBaseUrl() {
  const apiUrl = process.env.REACT_APP_API_URL;
  return apiUrl?.endsWith("/") ? apiUrl.slice(0, -1) : apiUrl || "";
}

const DEFAULT_PPE_ITEMS = [
  { header: "Safety Helmet", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Chin Strap for Safety Helmet", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "HV Vest", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "M/L/XL/XXL" }, { title: "N/A", value: false }] },
  { header: "HV Jacket", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "M/L/XL/XXL" }, { title: "N/A", value: false }] },
  { header: "HV Trousers", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "Waist & Length" }, { title: "N/A", value: false }] },
  { header: "HV Overalls", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "M/L/XL/XXL" }, { title: "N/A", value: false }] },
  { header: "Arc Proof Overalls", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "M/L/XL/XXL" }, { title: "N/A", value: false }] },
  { header: "Flame Retardant Overalls", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "M/L/XL/XXL" }, { title: "N/A", value: false }] },
  { header: "Safety Boots", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Ear Protection", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Safety Glasses", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Impact Goggles", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Gloves", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "8/9/10" }, { title: "N/A", value: false }] },
  { header: "Head Lamp", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "PPE Bag", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Individual First Aid Kit", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Medium Size First Aid Kit", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Large Size First Aid Kit", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Safe Isolation Lock Off Kit (Electricians only)", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
  { header: "Other Please Specify", items: [{ title: "Issued?", value: false }, { title: "Clean?", value: true }, { title: "Fit for Purpose?", value: true }, { title: "Replacement Required", value: false }, { title: "Size (if replacement required)", value: "" }, { title: "N/A", value: false }] },
];

const DEFAULT_TICKBOXES = {
  "I have checked my issued PPE and declare it fit for purpose as indicated.": false,
  "I am aware of the provisions to get my PPE cleaned and or replaced.": false,
  "I am aware of when I must wear my PPE and give a commitment to do so.": false,
  "I have been trained/ briefed in the correct use of my PPE.": false,
};

function parsePpeAnnualCheck(str) {
  if (!str) return JSON.parse(JSON.stringify(DEFAULT_PPE_ITEMS));
  if (Array.isArray(str)) return normalizePpeItems(str);
  if (typeof str === "object") {
    const source = Array.isArray(str?.ppeItems) ? str.ppeItems : [];
    return normalizePpeItems(source);
  }
  if (typeof str !== "string") return JSON.parse(JSON.stringify(DEFAULT_PPE_ITEMS));
  try {
    let s = str.replace(/(header|items|title|value)\s*:/g, '"$1":').replace(/'/g, '"');
    const parsed = JSON.parse(s);
    const source = Array.isArray(parsed) ? parsed : (Array.isArray(parsed?.ppeItems) ? parsed.ppeItems : []);
    return normalizePpeItems(source);
  } catch {
    return JSON.parse(JSON.stringify(DEFAULT_PPE_ITEMS));
  }
}

function normalizeLabel(value) {
  return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, "").trim();
}

function toBooleanLike(value) {
  if (typeof value === "boolean") return value;
  const s = String(value || "").trim().toLowerCase();
  if (!s) return false;
  return ["true", "yes", "y", "1", "checked"].includes(s);
}

function normalizePpeItems(input) {
  const base = JSON.parse(JSON.stringify(DEFAULT_PPE_ITEMS));
  if (!Array.isArray(input)) return base;
  const byHeader = new Map();
  const legacyByHeader = new Map();
  input.forEach((section) => {
    const header = String(section?.header || section?.item || section?.title || section?.name || section?.ppeItem || "").trim();
    if (!header) return;
    const items = Array.isArray(section?.items) ? section.items : [];
    if (items.length) {
      byHeader.set(normalizeLabel(header), {
        header,
        items: items.map((item) => ({
          title: String(item?.title || ""),
          value: item?.value ?? "",
        })),
      });
      return;
    }
    legacyByHeader.set(normalizeLabel(header), {
      issued: section?.issued ?? section?.isIssued ?? section?.declarationIssued,
      clean: section?.clean ?? section?.isClean,
      fit: section?.fitForPurpose ?? section?.fit ?? section?.fitForUse,
      replacement: section?.replacementRequired ?? section?.replacement ?? section?.replace,
      size: section?.size ?? section?.replacementSize ?? section?.sizeIfReplacementRequired,
      na: section?.na ?? section?.nA ?? section?.notApplicable ?? section?.ppeNa,
    });
  });
  return base.map((section) => {
    const key = normalizeLabel(section.header);
    const current = byHeader.get(key);
    const legacy = legacyByHeader.get(key);
    if (!current && !legacy) return section;
    const currentItemMap = new Map((Array.isArray(current?.items) ? current.items : []).map((item) => [normalizeLabel(item.title), item.value]));
    return {
      ...section,
      items: section.items.map((item) => {
        const k = normalizeLabel(item.title);
        if (currentItemMap.has(k)) return { ...item, value: currentItemMap.get(k) };
        if (!legacy) return item;
        if (k.includes("issued")) return { ...item, value: toBooleanLike(legacy.issued) };
        if (k.includes("clean")) return { ...item, value: toBooleanLike(legacy.clean) };
        if (k.includes("fitforpurpose")) return { ...item, value: toBooleanLike(legacy.fit) };
        if (k.includes("replacementrequired")) return { ...item, value: toBooleanLike(legacy.replacement) };
        if (k.includes("sizeifreplacementrequired")) return { ...item, value: legacy.size ?? "" };
        if (k === "na") return { ...item, value: toBooleanLike(legacy.na) };
        return item;
      }),
    };
  });
}

function normalizeTickboxes(input) {
  const mergeNormalized = (obj) => {
    const result = { ...DEFAULT_TICKBOXES };
    const targetEntries = Object.keys(DEFAULT_TICKBOXES).map((k) => [k, normalizeLabel(k)]);
    const targetByNormalized = new Map(targetEntries.map(([k, nk]) => [nk, k]));
    Object.entries(obj || {}).forEach(([rawKey, rawValue]) => {
      const sourceKey = String(rawKey || "").trim();
      if (!sourceKey) return;
      if (Object.prototype.hasOwnProperty.call(result, sourceKey)) {
        result[sourceKey] = toBooleanLike(rawValue);
        return;
      }
      const normalized = normalizeLabel(sourceKey);
      const direct = targetByNormalized.get(normalized);
      if (direct) {
        result[direct] = toBooleanLike(rawValue);
        return;
      }
      const loose = targetEntries.find(([, nk]) => nk.includes(normalized) || normalized.includes(nk));
      if (loose) result[loose[0]] = toBooleanLike(rawValue);
    });
    return result;
  };

  if (input && typeof input === "object" && !Array.isArray(input)) {
    return mergeNormalized(input);
  }
  if (typeof input === "string") {
    try {
      let parsed = null;
      try {
        parsed = JSON.parse(input);
      } catch {
        const normalized = input.replace(/'/g, '"');
        parsed = JSON.parse(normalized);
      }
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return mergeNormalized(parsed);
      }
    } catch {
      return { ...DEFAULT_TICKBOXES };
    }
  }
  return { ...DEFAULT_TICKBOXES };
}

function toPpeAnnualCheckString(arr) {
  if (!Array.isArray(arr)) return "";
  const safeArr = normalizePpeItems(arr);
  const str = safeArr.map((s) => {
    const itemStrs = (s.items || []).map((i) => {
      const v = i.value;
      const valPart = typeof v === "boolean" ? v : (v ? `'${String(v).replace(/'/g, "\\'")}'` : "''");
      return `{title:'${(i.title || "").replace(/'/g, "\\'")}',value:${valPart}}`;
    }).join(",");
    return `{header:'${(s.header || "").replace(/'/g, "\\'")}',items:[${itemStrs}]}`;
  }).join(",");
  return `[${str}]`;
}

function PPESelfCheckFormPage() {
  const canEditDelete = canEditDeleteRecords();
  const [forms, setForms] = useState([]);
  const [loadingRecords, setLoadingRecords] = useState(true);
  const [appUsers, setAppUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const isAdminUser = adminIsPrimaryAdmin();
  const [editForm, setEditForm] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [uploadingKey, setUploadingKey] = useState(null);
  const [showSharePointUploadModal, setShowSharePointUploadModal] = useState(false);
  const [sharePointUploadRecord, setSharePointUploadRecord] = useState(null);
  const [sharePointPhaseType, setSharePointPhaseType] = useState("phase");
  const [sharePointPhaseNumber, setSharePointPhaseNumber] = useState("15");
  const [sharePointNetwork, setSharePointNetwork] = useState("");
  const [pendingDirectUpload, setPendingDirectUpload] = useState(false);
  useEffect(() => {
    if (pendingDirectUpload && sharePointUploadRecord) {
      setPendingDirectUpload(false);
      // eslint-disable-next-line no-use-before-define
      handleSharePointUpload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingDirectUpload, sharePointUploadRecord]);
  const sigAddRef = useRef(null);
  const sigEditRef = useRef(null);

  const [newForm, setNewForm] = useState({
    formUuid: "",
    PPE_Annual_Check: JSON.parse(JSON.stringify(DEFAULT_PPE_ITEMS)),
    Tickboxesasappropriate: { ...DEFAULT_TICKBOXES },
    name: "",
    signature: "",
    date: "",
    comments: "",
    userId: "",
  });

  useEffect(() => {
    fetchForms();
    fetchAppUsers();
  }, []);

  async function fetchForms() {
    setLoadingRecords(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(getBaseUrl() + "/api/ppe-self-check-form", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.success && Array.isArray(data.data)) {
        setForms(data.data);
      } else {
        setForms([]);
      }
    } catch {
      setForms([]);
    } finally {
      setLoadingRecords(false);
    }
  }

  async function fetchAppUsers() {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(getBaseUrl() + "/api/app-users", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.success && Array.isArray(data.data)) {
        setAppUsers(data.data);
      } else {
        setAppUsers([]);
      }
    } catch {
      setAppUsers([]);
    }
  }

  const filtered = forms.filter((f) => {
    const fields = [f.name].map((v) => (v || "").toLowerCase());
    const words = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (words.length === 0) return true;
    return words.every((w) => fields.some((field) => field.includes(w)));
  });
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const paged = filtered.slice().slice((page - 1) * pageSize, page * pageSize);

  const handlePpeChange = (sectionIdx, itemIdx, value, isEdit) => {
    const apply = (prev) => {
      const ppe = [...prev.PPE_Annual_Check];
      const section = { ...ppe[sectionIdx], items: [...ppe[sectionIdx].items] };
      const items = section.items;
      const clicked = items[itemIdx];
      const isNaTitle = normalizeLabel(clicked.title) === "na";

      if (isNaTitle) {
        if (value === true) {
          section.items = items.map((it) => {
            const kn = normalizeLabel(it.title);
            if (kn === "na") return { ...it, value: true };
            if (kn.includes("issued") || kn === "clean" || kn.includes("fitforpurpose") || kn.includes("replacementrequired")) {
              return { ...it, value: false };
            }
            return it;
          });
        } else {
          section.items[itemIdx] = { ...clicked, value: false };
        }
      } else {
        const kn = normalizeLabel(clicked.title);
        const isFourBool =
          kn.includes("issued") || kn === "clean" || kn.includes("fitforpurpose") || kn.includes("replacementrequired");
        if (isFourBool && value === true) {
          const naI = items.findIndex((it) => normalizeLabel(it.title) === "na");
          section.items = items.map((it, j) => {
            if (j === itemIdx) return { ...it, value };
            if (j === naI) return { ...it, value: false };
            return it;
          });
        } else {
          section.items[itemIdx] = { ...clicked, value };
        }
      }

      ppe[sectionIdx] = section;
      return { ...prev, PPE_Annual_Check: ppe };
    };

    if (isEdit && editForm) {
      setEditForm(apply(editForm));
    } else {
      setNewForm(apply(newForm));
    }
  };

  const handleTickboxChange = (key, isEdit) => {
    if (isEdit && editForm) {
      const updated = { ...editForm.Tickboxesasappropriate, [key]: !editForm.Tickboxesasappropriate[key] };
      setEditForm({ ...editForm, Tickboxesasappropriate: updated });
    } else {
      const updated = { ...newForm.Tickboxesasappropriate, [key]: !newForm.Tickboxesasappropriate[key] };
      setNewForm({ ...newForm, Tickboxesasappropriate: updated });
    }
  };

  const handleAdd = async () => {
    if (!newForm.name || !newForm.date) {
      toast.error("Name and Date are required");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const payload = {
        PPE_Annual_Check: toPpeAnnualCheckString(newForm.PPE_Annual_Check),
        Tickboxesasappropriate: newForm.Tickboxesasappropriate,
        name: newForm.name,
        signature: newForm.signature || undefined,
        date: newForm.date,
        comments: newForm.comments || undefined,
        userId: newForm.userId || undefined,
        formUuid: ensureFormUuid(newForm.formUuid),
      };
      const res = await fetch(getBaseUrl() + "/api/ppe-self-check-form", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        if (noopCreateSuccess(data)) {
          toast.warn(data.message || "This record already exists. No new record was added.");
          return;
        }
        await fetchForms();
        setShowAddModal(false);
        setNewForm({
          formUuid: "",
          PPE_Annual_Check: JSON.parse(JSON.stringify(DEFAULT_PPE_ITEMS)),
          Tickboxesasappropriate: { ...DEFAULT_TICKBOXES },
          name: "",
          signature: "",
          date: "",
          comments: "",
          userId: "",
        });
        if (sigAddRef.current) sigAddRef.current.clear();
        toast.success("Form added!");
      } else {
        toast.error(data.message || "Failed to add");
      }
    } catch {
      toast.error("Failed to add");
    }
  };

  const handleEdit = (f) => {
    const ppeItems = parsePpeAnnualCheck(f.PPE_Annual_Check);
    const tickboxes = normalizeTickboxes(f.Tickboxesasappropriate);
    setEditForm({
      ...f,
      formUuid: ensureFormUuid(f?.formUuid),
      PPE_Annual_Check: ppeItems,
      Tickboxesasappropriate: tickboxes,
      date: f.date ? (() => {
        const d = parseSiteRegisterDate(f.date) || new Date(f.date);
        return d && !isNaN(d.getTime()) ? formatSiteRegisterDate(d) : "";
      })() : "",
    });
    setShowEditModal(true);
  };

  const handleEditSave = async () => {
    if (!editForm || !editForm._id) return;
    if (!editForm.name || !editForm.date) {
      toast.error("Name and Date are required");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const payload = {
        PPE_Annual_Check: toPpeAnnualCheckString(editForm.PPE_Annual_Check),
        Tickboxesasappropriate: editForm.Tickboxesasappropriate,
        name: editForm.name,
        signature: editForm.signature,
        date: editForm.date,
        comments: editForm.comments,
        userId: editForm.userId,
        formUuid: ensureFormUuid(editForm.formUuid),
      };
      const res = await fetch(getBaseUrl() + "/api/ppe-self-check-form/" + editForm._id, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        await fetchForms();
        setShowEditModal(false);
        setEditForm(null);
        toast.success("Form updated!");
      } else {
        toast.error(data.message || "Failed to update");
      }
    } catch {
      toast.error("Failed to update");
    }
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(getBaseUrl() + "/api/ppe-self-check-form/" + deleteId, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setForms(forms.filter((f) => f._id !== deleteId));
        toast.success("Form deleted!");
      } else {
        toast.error(data.message || "Failed to delete");
      }
    } catch {
      toast.error("Failed to delete");
    }
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const getUserName = (r) => {
    const uid = r.userId;
    const u = appUsers.find((x) => x._id === uid);
    return u ? `${u.firstName || ""} ${u.lastName || ""}`.trim() : (uid || "—");
  };

  const formatDate = (d) => {
    if (!d) return "—";
    const x = new Date(d);
    return isNaN(x.getTime()) ? "—" : x.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  const handleSharePointUpload = async () => {
    const locationForUpload = (sharePointUploadRecord?.name || "").trim();
    if (!locationForUpload) {
      toast.error("Name is missing for this record.");
      return;
    }
    if (sharePointPhaseType === "phase" && (!sharePointNetwork || sharePointNetwork.trim() === "")) {
      toast.error("Please select an area (EPN, LPN, or SPN)");
      return;
    }
    const payloadPhaseType = sharePointPhaseType === "phase" ? "phase" : "non-phase";
    const payloadNetwork = sharePointPhaseType === "phase" ? sharePointNetwork : "";
    const payloadPhaseNumber = sharePointPhaseType === "phase" ? sharePointPhaseNumber : "";
    setShowSharePointUploadModal(false);
    await generatePDF(sharePointUploadRecord, {
      uploadOnly: true,
      phaseType: payloadPhaseType,
      phaseNumber: payloadPhaseNumber,
      network: payloadNetwork,
      siteName: locationForUpload,
      onSuccess: () => {
        setSharePointUploadRecord(null);
        setSharePointPhaseType("phase");
        setSharePointPhaseNumber("15");
        setSharePointNetwork("");
      },
      onError: () => {}
    });
  };

  const generatePDF = async (record, options = {}) => {
    const shouldUploadToSharePoint = options.uploadOnly === true;
    const uploadConfig = shouldUploadToSharePoint
      ? {
          phaseType: options.phaseType || "non-phase",
          phaseNumber: options.phaseNumber || "",
          network: options.network || "",
          siteName: options.siteName || "",
          onSuccess: options.onSuccess,
          onError: options.onError
        }
      : null;

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const innerTableW = getInnerTableWidth(doc);
    let yPosition = await addLogoAndFormHeader(doc, "SF-006-B PPE Self Check Form");

    const ppeItems = parsePpeAnnualCheck(record.PPE_Annual_Check);
    const tick = normalizeTickboxes(record.Tickboxesasappropriate);

    const normalize = (s) => String(s || "").toLowerCase().replace(/\s+/g, " ").trim();
    const ppeMap = {};
    ppeItems.forEach((section) => {
      ppeMap[normalize(section.header)] = section;
    });

    const sizePlaceholderForHeader = (header) => {
      const def = DEFAULT_PPE_ITEMS.find((d) => normalize(d.header) === normalize(header));
      const v = def?.items?.[4]?.value;
      return v != null && String(v).trim() !== "" ? String(v) : "";
    };

    const sizeCellForPdf = (header, items) => {
      const raw = items[4]?.value;
      const placeholder = sizePlaceholderForHeader(header);
      const str = raw != null && String(raw).trim() !== "" ? String(raw) : placeholder;
      if (!str) return "";
      const isGray =
        placeholder &&
        (raw == null || String(raw).trim() === "" || String(raw).trim() === placeholder);
      if (isGray) {
        return { content: str, styles: { textColor: PDF_SIZE_PLACEHOLDER_GRAY, halign: "right", fontStyle: "normal" } };
      }
      return { content: str, styles: { halign: "right" } };
    };

    const isChecked = (value) => {
      const on = value === true || value === "true" || value === 1;
      return on;
    };
    const getRowByHeader = (header) => {
      const row = ppeMap[normalize(header)];
      const items = row?.items || [];
      const naEntry = items.find((it) => normalizeLabel(it?.title) === "na");
      return [
        header,
        isChecked(items[0]?.value) ? PDF_TICK : "",
        isChecked(items[1]?.value) ? PDF_TICK : "",
        isChecked(items[2]?.value) ? PDF_TICK : "",
        isChecked(items[3]?.value) ? PDF_TICK : "",
        sizeCellForPdf(header, items),
        isChecked(naEntry?.value) ? PDF_TICK : ""
      ];
    };

    const clearTickPlaceholder = (data) => {
      const tickCol = (data.column.index >= 1 && data.column.index <= 4) || data.column.index === 6;
      if (data.section !== "body" || !tickCol) return;
      const raw = data.cell.raw;
      const first = Array.isArray(data.cell.text) ? data.cell.text[0] : data.cell.text;
      if (raw === PDF_TICK || first === PDF_TICK) data.cell.text = [""];
    };

    const drawTickInCell = (data) => {
      const tickCol = (data.column.index >= 1 && data.column.index <= 4) || data.column.index === 6;
      if (data.section !== "body" || !tickCol) return;
      const raw = data.cell.raw;
      const first = Array.isArray(data.cell.text) ? data.cell.text[0] : data.cell.text;
      if (raw === PDF_TICK || first === PDF_TICK) {
        const centerX = data.cell.x + data.cell.width / 2;
        const centerY = data.cell.y + data.cell.height / 2;
        doc.addImage(CheckTick, "PNG", centerX - 1.8, centerY - 1.8, 3.6, 3.6);
      }
    };

    const drawSectionHeading = (label) => {
      doc.setFillColor(139, 22, 52);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.rect(10, yPosition, pageWidth - 20, 8, "F");
      doc.text(label, pageWidth / 2, yPosition + 5.3, { align: "center" });
      yPosition += 8;
    };

    drawSectionHeading("PERSONAL PROTECTIVE EQUIPMENT ANNUAL CHECK");

    const colItem = 30;
    const colRest = (innerTableW - colItem) / 6;
    const tableHead = [[
      { content: "Item", styles: { halign: "center", valign: "middle", fontStyle: "bold" } },
      { content: "Issued?", styles: { halign: "center", valign: "middle", fontStyle: "bold" } },
      { content: "Clean?", styles: { halign: "center", valign: "middle", fontStyle: "bold" } },
      { content: "Fit for\nPurpose?", styles: { halign: "center", valign: "middle", fontStyle: "bold" } },
      { content: "Replacement\nRequired", styles: { halign: "center", valign: "middle", fontStyle: "bold" } },
      { content: "Size\nif replacement required", styles: { halign: "center", valign: "middle", fontStyle: "bold", fontSize: 5.5 } },
      { content: "N/A", styles: { halign: "center", valign: "middle", fontStyle: "bold", fontSize: 7 } }
    ]];

    const page1Rows = [
      getRowByHeader("Safety Helmet"),
      getRowByHeader("Chin Strap for Safety Helmet"),
      getRowByHeader("HV Vest"),
      getRowByHeader("HV Jacket"),
      getRowByHeader("HV Trousers"),
      getRowByHeader("HV Overalls"),
      getRowByHeader("Arc Proof Overalls"),
      getRowByHeader("Flame Retardant Overalls"),
      getRowByHeader("Safety Boots"),
      getRowByHeader("Ear Protection"),
      getRowByHeader("Safety Glasses"),
      getRowByHeader("Impact Goggles"),
      getRowByHeader("Gloves"),
      getRowByHeader("Head Lamp"),
      getRowByHeader("PPE Bag"),
      [{ content: "First Aid Kits", colSpan: 7, styles: { fontStyle: "bold", halign: "left" } }],
      getRowByHeader("Individual First Aid Kit"),
      getRowByHeader("Medium Size First Aid Kit"),
      getRowByHeader("Large Size First Aid Kit")
    ];

    autoTable(doc, {
      startY: yPosition,
      head: tableHead,
      body: page1Rows,
      columnStyles: {
        0: { cellWidth: colItem },
        1: { cellWidth: colRest, halign: "center" },
        2: { cellWidth: colRest, halign: "center" },
        3: { cellWidth: colRest, halign: "center" },
        4: { cellWidth: colRest, halign: "center" },
        5: { cellWidth: colRest, halign: "right" },
        6: { cellWidth: colRest, halign: "center" }
      },
      styles: { font: "helvetica", fontSize: 7, cellPadding: 1.4, lineColor: [20, 20, 20], lineWidth: 0.2, minCellHeight: 8.6, valign: "middle" },
      margin: { left: 10, right: 10 },
      tableWidth: innerTableW,
      theme: "grid",
      headStyles: { fillColor: [139, 22, 52], textColor: [255, 255, 255], lineColor: [20, 20, 20], lineWidth: 0.2, minCellHeight: 10 },
      didParseCell: (data) => {
        if (data.section === "body" && data.row.index === 15 && data.column.index === 0) data.cell.styles.fontStyle = "bold";
        if (data.section === "body" && data.row.index >= 16 && data.column.index === 0) data.cell.styles.fontStyle = "normal";
        clearTickPlaceholder(data);
      },
      didDrawCell: (data) => {
        if (data.section === "body" && data.row.index === 15 && data.column.index === 0) {
          doc.setFont("helvetica", "bolditalic");
          doc.setTextColor(200, 30, 30);
          doc.setFontSize(6.6);
          doc.text("Check all First Aid items are included as per contents list and are in date", data.cell.x + 34, data.cell.y + 5.7);
          doc.setTextColor(0, 0, 0);
        }
        drawTickInCell(data);
      }
    });

    doc.addPage();
    yPosition = 14;
    drawSectionHeading("PERSONAL PROTECTIVE EQUIPMENT ANNUAL CHECK");

    const page2Rows = [
      getRowByHeader("Safe Isolation Lock Off Kit (Electricians only)"),
      ["Other\nPlease Specify", "", "", "", "", "", ""],
      ["Other\nPlease Specify", "", "", "", "", "", ""],
      ["Other\nPlease Specify", "", "", "", "", "", ""],
      ["Other\nPlease Specify", "", "", "", "", "", ""],
      ["Comments:", "", "", "", "", "", ""]
    ];

    autoTable(doc, {
      startY: yPosition,
      head: tableHead,
      body: page2Rows,
      columnStyles: {
        0: { cellWidth: colItem },
        1: { cellWidth: colRest, halign: "center" },
        2: { cellWidth: colRest, halign: "center" },
        3: { cellWidth: colRest, halign: "center" },
        4: { cellWidth: colRest, halign: "center" },
        5: { cellWidth: colRest, halign: "right" },
        6: { cellWidth: colRest, halign: "center" }
      },
      styles: { font: "helvetica", fontSize: 7, cellPadding: 1.4, lineColor: [20, 20, 20], lineWidth: 0.2, minCellHeight: 12, valign: "middle" },
      margin: { left: 10, right: 10 },
      tableWidth: innerTableW,
      theme: "grid",
      headStyles: { fillColor: [139, 22, 52], textColor: [255, 255, 255], lineColor: [20, 20, 20], lineWidth: 0.2, minCellHeight: 10 },
      didParseCell: (data) => {
        if (data.section === "body" && data.row.index === 0) data.cell.styles.minCellHeight = 12;
        if (data.section === "body" && data.row.index >= 1 && data.row.index <= 4) {
          data.cell.styles.minCellHeight = 12;
          if (data.column.index === 0) data.cell.styles.fontStyle = "italic";
        }
        if (data.section === "body" && data.row.index === 5) {
          data.cell.styles.minCellHeight = 26;
          if (data.column.index === 0) data.cell.styles.fontStyle = "normal";
        }
        clearTickPlaceholder(data);
      },
      didDrawCell: (data) => {
        drawTickInCell(data);
      }
    });

    yPosition = doc.lastAutoTable.finalY + 5;
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text("Tick boxes as appropriate (Replacement items can be obtained via the Stores Person)", 12, yPosition);
    yPosition += 5;

    const statements = [
      "I have checked my issued PPE and declare it fit for purpose as indicated.",
      "I am aware of the provisions to get my PPE cleaned and or replaced.",
      "I am aware of when I must wear my PPE and give a commitment to do so.",
      "I have been trained/ briefed in the correct use of my PPE."
    ];
    statements.forEach((line) => {
      if (tick[line]) doc.addImage(CheckTick, "PNG", 14, yPosition - 3.2, 3.4, 3.4);
      doc.text(line, 20, yPosition);
      yPosition += 5;
    });

    yPosition += 4;
    const nameText = record.name || "";
    doc.text(`Name: ${nameText} ....................................`, 12, yPosition);
    doc.text("Signature: ....................................", 95, yPosition);
    if (record.signature) {
      const src = String(record.signature).startsWith("data:") ? record.signature : `data:image/png;base64,${record.signature}`;
      try {
        doc.addImage(src, "PNG", 110, yPosition - 7, 38, 10);
      } catch {}
    }
    yPosition += 7;
    doc.text(`Date: ${record.date ? formatDate(record.date) : ""} ....................................`, 12, yPosition);
    yPosition += 6;
    doc.setTextColor(200, 30, 30);
    doc.text("Please forward completed form to Stores Supervisor & HSQE department for record keeping.", 12, yPosition);

    applyFooterAllPages(doc);

    const safeName = String(record.name || "PPE").replace(/[\\/:"*?<>|]+/g, "-");
    const safeDate = String(formatDate(record.date) || "form").replace(/[\\/:"*?<>|]+/g, "-");
    let fileName;
    if (shouldUploadToSharePoint && uploadConfig) {
      // No site is captured on this form, so the name is person + date only.
      fileName = buildSharePointFileName([record.name, toDdMmYyyy(record.date)]);
    } else {
      fileName = `SF006B_${safeName}_${safeDate}.pdf`;
    }

    if (shouldUploadToSharePoint && uploadConfig) {
      try {
        const key = `${record._id || ""}|${record.name || ""}|${record.date || ""}`;
        setUploadingKey(key);
        const apiUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
        const dataUri = doc.output("datauristring");
        const uploadParams = {
          fileName,
          fileBase64: dataUri,
          phaseType: uploadConfig.phaseType,
          phaseNumber: uploadConfig.phaseNumber,
          network: uploadConfig.network,
          siteName: uploadConfig.siteName, uploadContext: "hseq-forms-tablets", uploadSubFolder: "SF-006-B PPE Self Check Form"
        };
        const res = await fetch(`${apiUrl}/api/sharepoint/upload`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
          body: JSON.stringify(uploadParams)
        });
        if (res.status !== 204 && !res.ok) {
          let msg = "SharePoint upload failed";
          try {
            const out = await res.json();
            msg = out?.message || msg;
          } catch {
            /* ignore */
          }
          throw new Error(msg);
        }
        toast.success("PDF uploaded to SharePoint successfully!");
        if (uploadConfig.onSuccess) uploadConfig.onSuccess();
      } catch (err) {
        toast.error(err?.message || "SharePoint upload failed");
        if (uploadConfig.onError) uploadConfig.onError(err);
      } finally {
        setUploadingKey(null);
      }
    } else {
      doc.save(fileName);
      toast.success("SF-006-B PPE Self Check PDF generated successfully!");
    }
  };

  const renderPpeTable = (ppeItems, isEdit) => (
    <div style={{ overflowX: "auto", marginBottom: 14 }}>
      <div style={{ fontWeight: 700, color: THEME, marginBottom: 8, fontSize: 13 }}>PERSONAL PROTECTIVE EQUIPMENT ANNUAL CHECK</div>
      <table style={{ width: "100%", borderCollapse: "collapse", border: `1px solid ${THEME}`, fontSize: 12 }}>
        <thead>
          <tr style={{ background: THEME, color: "#fff" }}>
            <th style={{ padding: 6, textAlign: "left", border: `1px solid ${THEME}` }}>Item</th>
            <th style={{ padding: 6, textAlign: "center", border: `1px solid ${THEME}` }}>Issued?</th>
            <th style={{ padding: 6, textAlign: "center", border: `1px solid ${THEME}` }}>Clean?</th>
            <th style={{ padding: 6, textAlign: "center", border: `1px solid ${THEME}` }}>Fit for Purpose?</th>
            <th style={{ padding: 6, textAlign: "center", border: `1px solid ${THEME}` }}>Replacement Required</th>
            <th style={{ padding: 6, textAlign: "left", border: `1px solid ${THEME}` }}>Size (if replacement required)</th>
            <th style={{ padding: 6, textAlign: "center", border: `1px solid ${THEME}` }}>N/A</th>
          </tr>
        </thead>
        <tbody>
          {normalizePpeItems(ppeItems).map((section, sidx) => (
            <tr key={sidx} style={{ borderBottom: `1px solid ${THEME}` }}>
              <td style={{ padding: 5, border: `1px solid ${THEME}` }}>{section.header}</td>
              {(Array.isArray(section.items) ? section.items : []).map((item, iidx) => (
                <td key={iidx} style={{ padding: 5, border: `1px solid ${THEME}`, textAlign: item.title.includes("Size") && item.title.includes("replacement") ? "left" : "center", verticalAlign: "middle" }}>
                  {item.title.includes("Size") && item.title.includes("replacement") ? (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={item.value || ""}
                      onChange={(e) => handlePpeChange(sidx, iidx, e.target.value, isEdit)}
                      style={{ borderColor: THEME, maxWidth: 100, fontSize: 11, padding: "4px 6px" }}
                    />
                  ) : (
                    <input
                      type="checkbox"
                      className="form-check-input theme-checkbox"
                      checked={!!item.value}
                      onChange={() => handlePpeChange(sidx, iidx, !item.value, isEdit)}
                      style={{ width: 16, height: 16, accentColor: THEME, cursor: "pointer" }}
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderTickboxes = (tickboxes, isEdit) => (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontWeight: 600, color: THEME, marginBottom: 8, fontSize: 12 }}>Tick boxes as appropriate (Replacement items can be obtained via the Stores Person)</div>
      {Object.entries(tickboxes).map(([key, val]) => (
        <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
          <input
            type="checkbox"
            className="form-check-input theme-checkbox"
            checked={!!val}
            onChange={() => handleTickboxChange(key, isEdit)}
            style={{ marginRight: 8, width: 16, height: 16, accentColor: THEME, cursor: "pointer", flexShrink: 0 }}
          />
          <span style={{ fontSize: 12 }}>{key}</span>
        </div>
      ))}
    </div>
  );

  const renderFormFields = (form, isEdit, sigRef, onSigClear, onSigSave) => (
    <>
      <div style={{ marginBottom: 12 }}>
        <label style={{ fontWeight: 600, color: THEME, display: "block", marginBottom: 4, fontSize: 12 }}>Comments</label>
        <textarea
          className="form-control"
          value={form.comments || ""}
          onChange={(e) => (isEdit ? setEditForm((p) => ({ ...p, comments: e.target.value })) : setNewForm((p) => ({ ...p, comments: e.target.value })))}
          placeholder="Comments"
          rows={2}
          style={{ borderColor: THEME, borderRadius: 8, fontSize: 12 }}
        />
      </div>
      {renderTickboxes(form.Tickboxesasappropriate, isEdit)}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12, alignItems: "end" }}>
        <div>
          <label style={{ fontWeight: 600, color: THEME, display: "block", marginBottom: 4, fontSize: 12 }}>Name</label>
          <input
            type="text"
            className="form-control form-control-sm"
            value={form.name || ""}
            onChange={(e) => (isEdit ? setEditForm((p) => ({ ...p, name: e.target.value })) : setNewForm((p) => ({ ...p, name: e.target.value })))}
            placeholder="Name"
            style={{ borderColor: THEME, borderRadius: 8, fontSize: 12 }}
          />
        </div>
        <div>
          <label style={{ fontWeight: 600, color: THEME, display: "block", marginBottom: 4, fontSize: 12 }}>Date</label>
          {isEdit ? (
            <div className="site-register-datepicker-wrap">
              <DatePicker
                {...siteRegisterDatePickerProps}
                className="form-control form-control-sm"
                selected={parseSiteRegisterDate(form.date)}
                onChange={(d) => setEditForm((p) => ({ ...p, date: formatSiteRegisterDate(d) }))}
                style={{ borderColor: THEME, borderRadius: 8, fontSize: 12 }}
              />
            </div>
          ) : (
            <input
              type="date"
              className="form-control form-control-sm"
              value={form.date || ""}
              onChange={(e) => setNewForm((p) => ({ ...p, date: e.target.value }))}
              style={{ borderColor: THEME, borderRadius: 8, fontSize: 12 }}
            />
          )}
        </div>
        <div>
          <label style={{ fontWeight: 600, color: THEME, display: "block", marginBottom: 4, fontSize: 12 }}>Signature</label>
          {isEdit ? (
            <div
              style={{
                width: "100%",
                maxWidth: "280px",
                border: `2px solid ${THEME}`,
                borderRadius: "12px",
                background: "rgba(139,22,52,0.06)",
                padding: "12px",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {form.signature ? (
                <img
                  src={form.signature.startsWith("data:image") ? form.signature : `data:image/png;base64,${form.signature}`}
                  alt="Signature"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "80px",
                    objectFit: "contain",
                    borderRadius: "8px",
                    padding: "4px",
                    backgroundColor: "white",
                    border: "1px solid #e2e8f0",
                  }}
                  onError={(e) => { e.target.style.display = "none"; }}
                />
              ) : (
                <div style={{ color: "#94a3b8", fontSize: "13px", padding: "16px" }}>No signature</div>
              )}
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                maxWidth: "280px",
                border: `2px solid ${THEME}`,
                borderRadius: "12px",
                background: "rgba(139,22,52,0.06)",
                padding: "12px",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <SignatureCanvas
                ref={sigRef}
                penColor={THEME}
                backgroundColor="#f5eef0"
                clearOnResize={false}
                velocityFilterWeight={0.7}
                minWidth={1}
                maxWidth={2.5}
                dotSize={1.5}
                throttle={16}
                canvasProps={{
                  width: 250,
                  height: 80,
                  style: { width: "100%", height: "80px", border: "none", borderRadius: "8px", display: "block", touchAction: "none" },
                }}
                onEnd={onSigSave}
              />
              <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginTop: "8px" }}>
                <button
                  type="button"
                  onClick={onSigClear}
                  style={{
                    padding: "4px 12px",
                    borderRadius: "6px",
                    border: `1px solid ${THEME}`,
                    background: "transparent",
                    color: THEME,
                    fontSize: "12px",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div style={{ padding: 8, border: `1px solid ${THEME}`, borderRadius: 8, background: "#fdf2f4", textAlign: "center", color: THEME, marginBottom: 12, fontSize: 11 }}>
        Please forward completed form to Stores Supervisor & HSQE department for record keeping.
      </div>
    </>
  );

  return (
    <>
      <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0px 4px 20px rgba(0,0,0,0.08)", padding: 24, marginBottom: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, flexWrap: "wrap", gap: 16 }}>
          <h2 style={{ fontSize: 24, fontWeight: 700, color: "#1a202c", margin: 0 }}>SF-006-B PPE Self Check Form</h2>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            {isAdminUser && (
              <button
                type="button"
                onClick={() => setShowImportModal(true)}
                style={{
                  background: "#8b1634",
                  color: "#fff",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px 14px",
                  fontWeight: "600",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
              >
                Import File
              </button>
            )}
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <i className="fa fa-search" style={{ position: "absolute", left: 12, color: THEME, fontSize: 14, pointerEvents: "none", zIndex: 1 }} />
            <input
              type="text"
              placeholder="Type to Search"
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
              style={{ padding: "10px 12px 10px 36px", borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", width: 250, boxSizing: "border-box" }}
              onFocus={(e) => (e.target.style.borderColor = THEME)}
              onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
            />
          </div>
          </div>
        </div>
        <div style={{ overflowX: "auto", borderRadius: 12, border: "1px solid #e2e8f0" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr 1.2fr 1.5fr 1fr 1fr", background: "#f7fafc", padding: "12px 16px", borderBottom: "1px solid #e2e8f0", gap: 16, alignItems: "center" }}>
            <div style={{ fontWeight: 600, color: THEME, fontSize: 14 }}>Name</div>
            <div style={{ fontWeight: 600, color: THEME, fontSize: 14 }}>Date</div>
            <div style={{ fontWeight: 600, color: THEME, fontSize: 14 }}>Added By</div>
            <div style={{ fontWeight: 600, color: THEME, fontSize: 14 }}>Comments</div>
            <div style={{ fontWeight: 600, color: THEME, fontSize: 14 }}>Updated Date</div>
            <div style={{ fontWeight: 600, color: THEME, fontSize: 14 }}>Actions</div>
          </div>
          <div>
            {loadingRecords ? (
              <div style={{ textAlign: "center", padding: 40, color: THEME, fontSize: 16, fontWeight: 600 }}>
                <i className="fa fa-spinner fa-spin" style={{ marginRight: 8 }} />
                Loading records...
              </div>
            ) : paged.length === 0 ? (
              <div style={{ textAlign: "center", padding: 40, color: "#718096", fontSize: 16 }}>No records found.</div>
            ) : (
              paged.map((r, idx) => (
                <div
                  key={r._id || idx}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1.5fr 1fr 1.2fr 1.5fr 1fr 1fr",
                    padding: 16,
                    borderBottom: "1px solid #f1f5f9",
                    gap: 16,
                    alignItems: "center",
                  }}
                >
                  <div style={{ color: "#2d3748", fontSize: 14 }}>{r.name || "—"}</div>
                  <div style={{ color: "#2d3748", fontSize: 14 }}>{formatDate(r.date)}</div>
                  <div style={{ color: "#2d3748", fontSize: 14 }}>{getUserName(r)}</div>
                  <div style={{ color: "#2d3748", fontSize: 14, wordBreak: "break-word" }}>{r.comments || "—"}</div>
                  <div style={{ color: "#2d3748", fontSize: 14 }}>{formatDate(r.updatedAt || r.createdAt || r.date)}</div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    {canEditDelete && (
                      <button onClick={() => handleEdit(r)} title="Edit" style={{ background: "transparent", border: "none", cursor: "pointer", padding: 6 }}><i className="fa fa-edit" style={{ color: "#22c55e", fontSize: 16 }} /></button>
                    )}
                    <button type="button" onClick={() => generatePDF(r)} title="Generate PDF" style={{ background: "transparent", border: "none", cursor: "pointer", padding: 6 }}><i className="fa fa-file-pdf-o" style={{ color: "#dc2626", fontSize: 16 }} /></button>
                    {(() => {
                      const k = `${r._id || ""}|${r.name || ""}|${r.date || ""}`;
                      const busy = uploadingKey === k;
                      return (
                        <button
                          type="button"
                          onClick={() => {
                            if (!busy) {
                              setSharePointUploadRecord(r);
                              setSharePointPhaseType("phase");
                              setSharePointPhaseNumber("15");
                              setSharePointNetwork("");
                              setSharePointPhaseType("non-phase"); setPendingDirectUpload(true);
                            }
                          }}
                          disabled={busy}
                          title={busy ? "Uploading..." : "Upload to SharePoint"}
                          style={{ background: "transparent", border: "none", cursor: busy ? "not-allowed" : "pointer", padding: 6, opacity: busy ? 0.6 : 1 }}
                        >
                          <i className={busy ? "fa fa-spinner fa-spin" : "fa fa-upload"} style={{ color: "#22c55e", fontSize: 16 }} />
                        </button>
                      );
                    })()}
                    {canEditDelete && (
                      <button onClick={() => handleDelete(r._id)} title="Delete" style={{ background: "transparent", border: "none", cursor: "pointer", padding: 6 }}><i className="fa fa-trash" style={{ color: "#e53e3e", fontSize: 16 }} /></button>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: 18, gap: 12 }}>
          <button className="horizon-table-btn" disabled={page === 1} onClick={() => setPage(page - 1)} style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #e2e8f0", background: page === 1 ? "#f7fafc" : "#fff", color: page === 1 ? "#a0aec0" : THEME, cursor: page === 1 ? "not-allowed" : "pointer" }}>Prev</button>
          <span style={{ fontWeight: 700, color: THEME, fontSize: 16 }}>{page} / {totalPages}</span>
          <button className="horizon-table-btn" disabled={page === totalPages} onClick={() => setPage(page + 1)} style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #e2e8f0", background: page === totalPages ? "#f7fafc" : "#fff", color: page === totalPages ? "#a0aec0" : THEME, cursor: page === totalPages ? "not-allowed" : "pointer" }}>Next</button>
        </div>
      </div>

      {showAddModal && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.3)" }} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" style={{ maxWidth: 1200, margin: "0 auto" }}>
              <div className="modal-header" style={{ background: THEME, color: "#fff" }}>
                <h5 className="modal-title">Add PPE Self Check Form</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowAddModal(false)} />
              </div>
              <div className="modal-body">
                {renderPpeTable(newForm.PPE_Annual_Check, false)}
                {renderFormFields(newForm, false, sigAddRef, () => { if (sigAddRef.current) sigAddRef.current.clear(); setNewForm((p) => ({ ...p, signature: "" })); }, () => { if (sigAddRef.current && !sigAddRef.current.isEmpty()) setNewForm((p) => ({ ...p, signature: sigAddRef.current.getTrimmedCanvas().toDataURL("image/png") })); })}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Cancel</button>
                <button type="button" className="btn" style={{ background: THEME, color: "#fff", fontWeight: 600 }} onClick={handleAdd}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditModal && editForm && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.3)" }} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" style={{ maxWidth: 1200, margin: "0 auto" }}>
              <div className="modal-header" style={{ background: THEME, color: "#fff" }}>
                <h5 className="modal-title">Edit PPE Self Check Form</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowEditModal(false)} />
              </div>
              <div className="modal-body">
                {renderPpeTable(editForm.PPE_Annual_Check, true)}
                {renderFormFields(editForm, true, sigEditRef, () => { if (sigEditRef.current) sigEditRef.current.clear(); setEditForm((p) => ({ ...p, signature: "" })); }, () => { if (sigEditRef.current && !sigEditRef.current.isEmpty()) setEditForm((p) => ({ ...p, signature: sigEditRef.current.getTrimmedCanvas().toDataURL("image/png") })); })}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                <button type="button" className="btn" style={{ background: THEME, color: "#fff", fontWeight: 600 }} onClick={handleEditSave}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSharePointUploadModal && sharePointUploadRecord && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.3)" }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ maxWidth: 600, margin: "0 auto" }}>
              <div className="modal-header">
                <h5 className="modal-title">Upload to SharePoint</h5>
                <button type="button" className="btn-close" onClick={() => { setShowSharePointUploadModal(false); setSharePointUploadRecord(null); setSharePointPhaseType("phase"); setSharePointPhaseNumber("15"); setSharePointNetwork(""); }} />
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="mb-3 col-12">
                    <label className="form-label fw-semibold">Type <span style={{ color: "red" }}>*</span></label>
                    <select className="form-select" value={sharePointPhaseType} onChange={(e) => { setSharePointPhaseType(e.target.value); if (e.target.value === "non-phase") setSharePointNetwork(""); }}>
                      <option value="phase">Phase</option>
                      <option value="non-phase">Non Phase</option>
                    </select>
                  </div>
                  {sharePointPhaseType === "phase" && (
                    <>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Phase Number <span style={{ color: "red" }}>*</span></label>
                        <select className="form-select" value={sharePointPhaseNumber} onChange={(e) => setSharePointPhaseNumber(e.target.value)}>
                          <option value="15">Phase 15 (2025)</option>
                          <option value="16">Phase 16 (2026)</option>
                        </select>
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Area <span style={{ color: "red" }}>*</span></label>
                        <select className="form-select" value={sharePointNetwork} onChange={(e) => setSharePointNetwork(e.target.value)}>
                          <option value="">Select Area</option>
                          <option value="EPN">EPN</option>
                          <option value="LPN">LPN</option>
                          <option value="SPN">SPN</option>
                        </select>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => { setShowSharePointUploadModal(false); setSharePointUploadRecord(null); setSharePointPhaseType("phase"); setSharePointPhaseNumber("15"); setSharePointNetwork(""); }}>Cancel</button>
                <button type="button" className="btn" style={{ background: THEME, color: "#fff", fontWeight: 600 }} onClick={handleSharePointUpload}>Upload to SharePoint</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AdminTaylorImportModal
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        title="Upload SF-006-B PPE Self Check Form File"
        importPath="ppe-self-check-form/import-form"
        isAdminUser={isAdminUser}
        onImported={({ insertedRow }) => {
          if (insertedRow && insertedRow._id) {
            setForms((prev) => [insertedRow, ...prev]);
            setPage(1);
          }
        }}
      />

      {showDeleteModal && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.3)" }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete PPE Self Check Form</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)} />
              </div>
              <div className="modal-body">Are you sure you want to delete this form?</div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={confirmDelete}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PPESelfCheckFormPage;
